import React from 'react'
import { useTranslation } from 'react-i18next'
import { Stack, Typography } from '@mui/material'
import { FragmentType, graphql, useFragment } from '@/generated/gql'
import { numberFormat } from '@/helpers/numbers'

const canteenCartCurrentCreditsCurrentMenuDataFragment = graphql(`
  fragment CanteenCartCurrentCredits_CurrentMenuDataFragment on CCMealService {
    availableSubsidy
  }
`)

const canteenCartCurrentCreditsUserDataFragment = graphql(`
  fragment CanteenCartCurrentCredits_UserDataFragment on User {
    account {
      topUpEnabled
    }
    wallet {
      balance
    }
    subsidySettings {
      unlimitedSubsidy
    }
  }
`)

interface Props {
  menuData: FragmentType<typeof canteenCartCurrentCreditsCurrentMenuDataFragment>
  userData: FragmentType<typeof canteenCartCurrentCreditsUserDataFragment>
}

const CurrentCredits: React.FC<Props> = ({ menuData: menuDataProp, userData: userDataProp }) => {
  const userData = useFragment(canteenCartCurrentCreditsUserDataFragment, userDataProp)
  const menuData = useFragment(canteenCartCurrentCreditsCurrentMenuDataFragment, menuDataProp)
  const topUpEnabled = Boolean(userData.account?.topUpEnabled)
  const { t } = useTranslation()
  return (
    <Stack spacing={1} direction="row">
      {topUpEnabled && (
        <Stack alignItems="center" direction="column" data-cy="current-personal-credits">
          <Typography variant="body2">{numberFormat(userData.wallet.balance)}</Typography>
          <Typography variant="caption">{t('credits').toLowerCase()}</Typography>
        </Stack>
      )}
      <Stack alignItems="center" direction="column" data-cy="current-subsidy-credits">
        <Typography color="success.main" variant="body2">
          {userData.subsidySettings.unlimitedSubsidy
            ? t('cc:unlimited')
            : numberFormat(menuData.availableSubsidy)}
        </Typography>
        <Typography color="success.main" variant="caption">
          {t('free').toLowerCase()}
        </Typography>
      </Stack>
    </Stack>
  )
}

export default CurrentCredits
